import React from "react";
import { FOOTER } from "../../../layout/eng/footer";
import { SUBHEADER } from "../../../layout/eng/subheader";
import { EN_Management } from "../../../parts/eng/business/management";
import { Helmet } from "react-helmet";
export const EN_MANAGEMENT = () => {
  return (
    <main id="content">
      <SUBHEADER />
      <div id="business">
        <EN_Management />
      </div>
      <FOOTER />
    </main>
  );
};
